import { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../redux/store';
import { useNavigate, useParams } from 'react-router-dom';
import qs from 'qs';
import { Placeholder } from '../components/Placeholder';
import { fetchMyStore, postMyStore } from '../redux/lounges/slice';
import { selectLounges } from '../redux/lounges/selectors';
import { usersSelector } from '../redux/users/selectors';
import { useForm } from 'react-hook-form';
import { LoungeHeader } from '../components/LoungeHeader';
import { MobileLoungeHeader } from '../components/MobileLoungeHeader';
import PureModal from 'react-pure-modal';
import 'react-pure-modal/dist/react-pure-modal.min.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GET_BASE_URL_IMAGE } from '../constants/apiEndpoints';
import { StoreTabs } from '../components/StoreTabs';
import { LoungeSignInPrompt } from '../components/LoungeSignInPrompt';
import {
  formatLoungeCreditBalance,
  isKnownNumericCreditBalance,
  LOUNGE_MUTATION_RETRY_MESSAGE,
  useLoungeSessionExpired,
  userFacingMutationMessage,
} from '../utils/loungeSession';
import {
  getMyStoreRows,
  isRejectedStoreAction,
  readMyStorePurchaseMessage,
  STORE_PURCHASE_SUCCESS_FALLBACK,
} from '../utils/myStorePurchase';

// @ts-ignore
import { Helmet } from 'react-helmet-async';

const MyStore = () => {
  const dispatch = useAppDispatch();
  const { myStoreItem, status } = useSelector(selectLounges);
  const sessionExpired = useLoungeSessionExpired();
  console.log('uyoga');

  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');
  const { isLoggedIn } = useSelector(usersSelector);

  let sortType: any = null;
  let categoryId: any = null;
  let currentPage: any = null;
  let searchValue: any = null;
  const navigate = useNavigate();
  const purchaseInFlightRef = useRef(false);
  const storeFetchRef = useRef<{ abort?: () => void } | null>(null);

  const dispatchStoreFetch = () => {
    storeFetchRef.current?.abort?.();
    const dispatched = dispatch(fetchMyStore({ sortType, currentPage })) as {
      abort?: () => void;
    };
    storeFetchRef.current = dispatched;
    return dispatched;
  };

  useEffect(() => {
    if (token == null) {
      navigate('/disneyland/login');
    }

    window.scrollTo(0, 0);
    dispatchStoreFetch();
  }, []);

  const {
    register,
    setValue,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<FormData>();

  const [modal, setModal] = useState(false);
  const [Id, setId] = useState<number | any>('');
  const [purchasePending, setPurchasePending] = useState(false);
  const [refreshFailed, setRefreshFailed] = useState(false);
  const [storeNotice, setStoreNotice] = useState<{
    kind: 'success' | 'error';
    message: string;
  } | null>(null);
  type FormData = {
    Id: number;
  };
  useEffect(() => {
    if (token == null) {
      navigate('/disneyland/login');
    }

    setValue('Id', Id);
  }, [Id]);

  const storeRows = getMyStoreRows(myStoreItem);
  const showStoreSkeleton = status === 'loading' && storeRows.length === 0;

  const beginPurchase = () => {
    if (purchaseInFlightRef.current) {
      return false;
    }
    purchaseInFlightRef.current = true;
    setPurchasePending(true);
    return true;
  };

  const endPurchase = () => {
    purchaseInFlightRef.current = false;
    setPurchasePending(false);
  };

  const myStoreBuy = (nextId: any) => {
    if (token == null) {
      navigate('/disneyland/login');
      return;
    }
    if (purchaseInFlightRef.current || purchasePending) {
      return;
    }
    setModal(true);
    setId(nextId);
  };

  const refreshStoreAfterPurchase = async () => {
    setRefreshFailed(false);
    try {
      const refresh = await dispatchStoreFetch();
      if (isRejectedStoreAction(refresh)) {
        setRefreshFailed(true);
      }
    } catch {
      setRefreshFailed(true);
    }
  };

  const onSubmit = async (data: any) => {
    if (token == null) {
      navigate('/disneyland/login');
      return;
    }
    if (!beginPurchase()) {
      return;
    }

    setStoreNotice(null);
    setRefreshFailed(false);

    try {
      const result = await dispatch(postMyStore(data));
      if (isRejectedStoreAction(result)) {
        throw result.payload ?? result;
      }
      const payload = result?.payload ?? result;
      const message = readMyStorePurchaseMessage(
        payload,
        STORE_PURCHASE_SUCCESS_FALLBACK
      );
      setStoreNotice({ kind: 'success', message });
      toast.success(message);
      setModal(false);
      await refreshStoreAfterPurchase();
    } catch (error) {
      const message = userFacingMutationMessage(
        error,
        LOUNGE_MUTATION_RETRY_MESSAGE
      );
      if (message) {
        setStoreNotice({ kind: 'error', message });
        toast.error(message);
      }
      setModal(false);
    } finally {
      endPurchase();
    }
  };

  return (
    <>
      <Helmet>
        <title>Mousewait Store</title>
        <meta property='og:title' content='Mousewait' />
        <meta
          property='og:image'
          content='https://mousewait.com/static/media/MouseWait-img.fed12113160621608cfe.png'
        />
        <meta
          property='og:description'
          content='MouseWait provides a wealth of information for both casual and frequent visitors to the Disneyland Resort. It does exactly what it claims and more, and it does it extremely well. '
        />
      </Helmet>

      <div className='mid-main'>
        <div className='container'>
          <div className='mid-sec mwstore-page-bg'>
            <LoungeHeader />
            <MobileLoungeHeader />
            <div className='mwstore-mid-bg'>
              <StoreTabs />
              <ToastContainer
                className='mw-store-toasts'
                position='top-center'
                autoClose={4000}
                newestOnTop
                closeOnClick
                pauseOnHover
                hideProgressBar
                limit={2}
                draggable={false}
              />

                <PureModal
                  header='Please Confirm'
                  isOpen={modal}
                  closeButton={<i className='fa fa-close my-b' />}
                  closeButtonPosition='bottom'
                  onClose={() => {
                    if (purchaseInFlightRef.current || purchasePending) {
                      return false;
                    }
                    setModal(false);
                    return true;
                  }}
                >
                  <form
                    className='space-y-6'
                    onSubmit={handleSubmit(onSubmit)}
                    method='POST'
                  >
                    <div style={{ position: 'fixed', top: '2.7rem' }}>
                      <input type='hidden' {...register('Id')} />

                      <div
                        style={{
                          position: 'fixed',
                          width: '100%',
                          height: '10rem',
                          left: '0',
                          background: '#fff',
                          padding: '1rem',
                          fontSize: '14px',
                          wordBreak: 'break-word',
                        }}
                      >
                        By clicking Submit you will purchase this item with your
                        Credits and it cannot be undone, are you sure?
                      </div>

                      <div
                        className='mw-post text-center'
                        style={{
                          position: 'fixed',
                          top: '8rem',
                        }}
                      >
                        <button
                          className='MW-btn'
                          type='submit'
                          disabled={purchasePending}
                          style={{ padding: '0.2rem 0.7rem' }}
                        >
                          {purchasePending ? 'Purchasing...' : 'Submit'}
                        </button>
                      </div>
                    </div>
                  </form>
                </PureModal>

                  <div className='mws-mid-sec'>
                    <h5 className='mid-head'>MouseWait Store</h5>
                    {sessionExpired ? (
                      <LoungeSignInPrompt
                        title="Session expired"
                        message="Sign in again to see available credits and the sticker store. Refreshing keeps the same expired sign-in."
                      />
                    ) : (
                      <>
                    <h6 className='mid-sub'>
                      <span>
                        {isKnownNumericCreditBalance(
                          (myStoreItem as any).credit_balance
                        )
                          ? `Credit Balance : ${(myStoreItem as any).credit_balance}`
                          : formatLoungeCreditBalance(
                              (myStoreItem as any).credit_balance
                            )}
                      </span>
                    </h6>
                    <h6 className='mt-2'>
                      <span>
                        Purchase Stickers with MouseWait Credits below. You can
                        use this sticker you own in the Lounge just as you would
                        use emojis!
                      </span>
                    </h6>
                    {storeNotice && (
                      <h6
                        className='mt-2'
                        role={storeNotice.kind === 'error' ? 'alert' : 'status'}
                      >
                        <span>{storeNotice.message}</span>
                      </h6>
                    )}
                    {refreshFailed && (
                      <h6 className='mt-2' role='alert'>
                        <span>
                          Store updated on the server, but this list could not
                          refresh.{' '}
                          <button
                            type='button'
                            className='MW-btn'
                            onClick={() => {
                              void refreshStoreAfterPurchase();
                            }}
                          >
                            Retry
                          </button>
                        </span>
                      </h6>
                    )}
                      </>
                    )}
                  </div>

                  {!sessionExpired && <div className='mws-table-main mwstore-table mt-2'>
                    <div className='table-responsive'>
                      <table className='table table-borderless'>
                        <thead>
                          <tr className='tab-nav'>
                            <th
                              style={{ width: '15%', fontWeight: '500' }}
                              scope='col'
                            >
                              Sticker
                            </th>
                            <th
                              style={{ width: '20%', fontWeight: '500' }}
                              scope='col'
                            >
                              Name
                            </th>
                            <th
                              style={{ width: '14%', fontWeight: '500' }}
                              scope='col'
                            >
                              Desc
                            </th>
                            <th
                              style={{ width: '18%', fontWeight: '500' }}
                              scope='col'
                            >
                              Qty
                            </th>
                            <th
                              style={{ width: '13%', fontWeight: '500' }}
                              scope='col'
                            >
                              Credits
                            </th>
                            <th
                              style={{ width: '20%', fontWeight: '500' }}
                              scope='col'
                            >
                              Action
                            </th>
                          </tr>
                        </thead>

                        <tbody className='tab-body' aria-busy={purchasePending}>
                          {showStoreSkeleton
                            ? [...new Array(9)].map((_, index) => (
                                <Placeholder key={index} />
                              ))
                            : storeRows.map((obj: any) => (
                                <tr className='in-sec' key={obj.id}>
                                  <th scope='row'>
                                    <div className='tab-img'>
                                      <img
                                        src={
                                          GET_BASE_URL_IMAGE +
                                          '/disneyland/images/products_fullsize/' +
                                          obj.product_image
                                        }
                                        className='img-fluid'
                                        alt='big-top'
                                      />
                                    </div>
                                  </th>
                                  <td style={{ fontWeight: '500' }}>
                                    {obj.product_name}
                                  </td>
                                  <td style={{ fontWeight: '500' }}>
                                    {obj.product_description}
                                  </td>
                                  <td style={{ fontWeight: '500' }}>
                                    {obj.product_quantity}
                                  </td>
                                  <td style={{ fontWeight: '500' }}>
                                    {obj.product_price}
                                  </td>
                                  {obj.product_quantity > 0 &&
                                  obj.isauction == 0 ? (
                                    <td>
                                      <a
                                        onClick={() => myStoreBuy(obj.id)}
                                        aria-disabled={purchasePending}
                                        style={{
                                          background: '#a0b7e9',
                                          borderRadius: '0.5rem',
                                          padding: '0.5rem',
                                          fontSize: '1rem',
                                          textDecoration: 'none',
                                          color: '#fff',
                                          pointerEvents: purchasePending
                                            ? 'none'
                                            : 'auto',
                                          opacity: purchasePending ? 0.65 : 1,
                                        }}
                                        type='button'
                                        className='buy-b mycollection-buy'
                                      >
                                        Buy
                                      </a>
                                    </td>
                                  ) : (
                                    <td></td>
                                  )}
                                </tr>
                              ))}
                        </tbody>
                      </table>
                    </div>
                  </div>}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MyStore;
